import type { App } from 'vue';
import VueTippy from 'vue-tippy';
import 'tippy.js/dist/tippy.css';

/**
 * Tooltip provider configuration
 * Uses VueTippy for displaying tooltips with the v-tippy directive
 */
export function setupTooltips(app: App) {
  app.use(VueTippy, {
    directive: 'tippy',
  });
}

